import { AddressBookConfigSection } from "@/apidtos";
import { useRootLoaderData } from "@/root"

export const useAddressBookConfig = () => {
  const { config } = useRootLoaderData();
  return config.AddressBook as AddressBookConfigSection;
};
